
import { CalendarProvider } from "pages/school/ClassesPage/ClassesDetail/Stores/CalendarProvider";
import { memo, useState } from "react";
import PlanningManager from "./PlanningManager";
import PlanningManagerTop from "./PlanningManagerTop";

const Planning = ({
  infoMembers, classe, training, idParam, from
}) => {

  const ISCLASSAUTHORIZED = false;

  return (
    <>
      <PlanningManager
        classroomId={idParam}
        isClassAuthorized={ISCLASSAUTHORIZED}
        from={from}
        students={infoMembers}
        classroomName={classe?.label}
        trainingName={training?.label}
        trainingDegree={training?.degree?.label}
        classe={classe}
      />
    </>
  )
}

export default memo(Planning);